import React from 'react';
import clsx from 'clsx';
import { Content } from 'common/types/app-api/content';
import { ContentPageHeader } from './header';
import styles from './index.module.styl';
type ContentPageProps = {
  projectId: number;
  workspaceId: number;
  userId: number;
  content?: Content;
  header?: React.ReactNode;
  children?: React.ReactNode;
  hasUnsavedChanges?: boolean;
  minWidth?: number;
  /** This callback is run when the page gets clicked anywhere.
   *
   * This is useful for clearing a selection when the page background is clicked
   * for example. If you are doing that, make sure to use
   * `event.stopPropagation()` on any child elements that should not trigger
   * this callback.
   */
  onClick?: () => void;
  onUpdate?: (content: Content) => void;
  onCommit?: () => void;
  onRevert?: () => void;
};
export function ContentPage(_ref: ContentPageProps) {
  let {
    projectId,
    workspaceId,
    userId,
    content,
    header,
    children,
    hasUnsavedChanges = false,
    minWidth,
    onClick,
    onUpdate = () => {
      /* Default no-op function */
    },
    onCommit,
    onRevert
  }: ContentPageProps = _ref;
  return <div className={clsx(styles.wrapper, {
    [styles.hasMinWidth]: minWidth
  })} onClick={onClick} data-sentry-component="ContentPage" data-sentry-source-file="index.tsx">
      <div className={styles.wrapperInner} style={{
      minWidth: minWidth ? "".concat(minWidth, "px") : undefined
    }}>
        {header !== null && header !== void 0 ? header : <ContentPageHeader projectId={projectId} workspaceId={workspaceId} userId={userId} content={content} onUpdate={onUpdate} hasUnsavedChanges={hasUnsavedChanges} onCommit={onCommit} onRevert={onRevert} />}
        <div className={styles.wrapperContent}>{children}</div>
      </div>
    </div>;
}